import {apiSlice} from './api/apiSlice';
import {configureStore} from '@reduxjs/toolkit';

import rootReducer from './reducers';

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      // WARNING! The checks here are valuable but they have a
      // significant impact on performance.
      serializableCheck: false,
      immutableCheck: true,
    }).concat(apiSlice.middleware),
});

export default store;
